import React from 'react';
import Button from '@fff-web/fff-ui-shared/Button';
import { useCurrentWidth } from '@fff-web/fff-ui-shared/hooks';
import { useUserContext } from '@fff-web/fff-utilities';
import { track } from '@fff-web/fff-analytics';
import { getQueryParam } from '../../MyAccount/utils/url';
import breakpoints from '../../../utils/breakpoints';
import { redirectToLogin } from '../../../utils/redirectMethods';
import { useReactivateMyMembershipContext } from '../../../utils/ContextProviders/ReactivateContext';

export const REACTIVATE_NOW_CTA = 'REACTIVATE NOW';
const DESKTOP_WIDTH = 286;
const MOBILE_WIDTH = 351;
const REACTIVATE_INITIATED_EVENT_NAME = 'Reactivate Initiated';

const ReactivateButton = ({ styles, scrollToRef }) => {
  const currentWidth = useCurrentWidth();
  const isDesktop = currentWidth > breakpoints.medium;
  const width = isDesktop ? DESKTOP_WIDTH : MOBILE_WIDTH;
  const { userInfo } = useUserContext();
  const { btnContainerRef } = useReactivateMyMembershipContext();

  const handleClick = (evt) => {
    if (!userInfo.loggedIn) {
      track({
        trackName: REACTIVATE_INITIATED_EVENT_NAME,
        properties: {
          coupon_code: getQueryParam('coupon_code'),
          cta_name: evt.target?.innerText || REACTIVATE_NOW_CTA,
        },
      });
      redirectToLogin();
    }
    if (btnContainerRef?.current) {
      const scrollOptions = {
        top: btnContainerRef.current.offsetTop,
        behavior: 'smooth',
      };
      window.scrollTo(scrollOptions);
    }
  };

  return (
    <Button
      styles={styles}
      width={width}
      height={54}
      onClick={handleClick}
      variation="rounded-primary"
    >
      {REACTIVATE_NOW_CTA}
    </Button>
  );
};

export default ReactivateButton;
